// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2-RT8","row":"styles_row__1wFpg"};